import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Link, useParams } from 'react-router-dom';

import { ArrowRight, CheckCheck } from "lucide-react";
import { LuRefreshCw } from "react-icons/lu";

import axiosInstance from 'utils/axiosInstance';

import LatestStatsComments from "./components/LatestStatsComments";
import LatestStatsNumbers from "./components/LatestStatsNumbers";

import { TransitionGroup, CSSTransition } from 'react-transition-group';

const InfoQuestionForum = ({ 
  t, 
}) => {

  const containerRef = useRef(null);

  const { questionId } = useParams();
  useEffect(()=>{
    console.log('questionId:', questionId);
  },[])

  return (
    <div className="page-content" style={{ 
      maxHeight: "100vh",
      padding: "70px 0px 0px 0px",

      width: "100%",
      height: "100%",
    }}>
      <div ref={containerRef}>
        <Container
          fluid
          style={{ 
            minHeight: "calc(98vh)",
            maxHeight: "calc(98vh)",
            overflow: "hidden",
            //border: "3px solid black",
            padding: "0",
            height: "90vh"
          }}
        >

          <Row style={{ height: "100%" }}>
            <Col xs={12}>

              <Row style={{ height: "100%" }}>
                <Col xs={9}>

                  <Row style={{ height: "30%" }}>
                    <LatestStatsNumbers
                    />
                  </Row>

                  <Row style={{ height: "70%" }}>
                    <Col xs={12} style={{ background: "beige" }}>

                    </Col>
                  </Row>

                </Col>

                 <Col xs={3}>
                  <Row style={{ height: "100%" }}>
                    <LatestStatsComments
                    />
                  </Row>
                </Col>
              </Row>

            </Col>
          </Row>

        </Container>
      </div>
    </div>
  );
};

export default withTranslation()(InfoQuestionForum);


